import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/vercel/path0/layouts/default.vue").then(m => m.default || m)),
  league: defineAsyncComponent(() => import("/vercel/path0/layouts/league.vue").then(m => m.default || m)),
  team: defineAsyncComponent(() => import("/vercel/path0/layouts/team.vue").then(m => m.default || m))
}